/**
 * Tracks sprint IDs currently being created via POST.
 * Prevents progress-sync / save from issuing PUT before create completes.
 */
const pending = new Set();

export function markSprintCreatePending(id) {
  if (id) pending.add(id);
}

export function clearSprintCreatePending(id) {
  if (id) pending.delete(id);
}

export function isSprintCreatePending(id) {
  return id ? pending.has(id) : false;
}
